export const Ru = {
  'custom-domain': 'Кастомный домен',
  'telegram-chat-id': 'ID телеграм чата',
  'plan-2d-status': 'Статусы 2D планировок',
  'plan-3d-status': 'Статусы 3D планировок',
  'webhook-token': 'Webhook token',
  'webhook-url': 'Webhook URL',
  webhook: 'Webhook',
  token: 'Token',
  'branding-id': 'ID брендинга',
  'domen-name': 'Доменное имя',
  'company-name': 'Название компании',
  user: 'Пользователь',
  ninja: 'Ниндзя',
  cutter: 'Резчик',
  manager: 'Менеджер',
  branding: 'Брендинг',
  name: 'Имя',
  email: 'Email',
  role: 'Роль',
  number: 'Номер',
  status: 'Статус',
  'status-3d': 'Статус 3D',
  tags: 'Теги',
  tag: 'Тег',
  priority: 'Приоритет',
  'crm-project-type': 'Тип проекта',
  'ue-name': 'Имя в Unreal',
  merged: 'Слита',
  'merged-id': 'Слили с планировкой ID',
  'original-plan': 'Оригинал',
  'original-plan-status': 'Статус оригинала',
  'plan-number-in-apartment': 'Номер планировки',
  identifiers: 'Идентификаторы',
  'individual-style': 'Индивидуальный стиль',
  'has-panorama': 'Виртуальный тур',
  ruler: 'Линейка',
  'interactive-top-view': 'Интерактивный вид сверху',
  'top-view-as-mini-plan': 'Вид сверху в миниплане',
  'projection-mode': 'Тип проекции для топ видов',
  'camera-navigation': 'Тип навигации',
  'hidden-furniture': 'Скрыта необязательная мебель',
  'transparent-background': 'Прозрачный фон',
  'rtx-quality': 'Качество рендера',
  'is-webp-enabled': 'Формат изображения',
  unreal_style: 'Стиль',
  'responsible-ninjas-2d': 'Ответственные 2D',
  'responsible-ninjas-3d': 'Ответственные 3D',
  region: 'Регион',
  developer: 'Застройщик',
  complex: 'ЖК',
  address: 'Адрес',
  'same-ninja-for-2d-and-3d-plans': 'Один ниндзя для 2Д и 3Д',
  'same-reviewer-for-2d-and-3d-plans': 'Один проверяющий для 2Д и 3Д',
  description: 'Описание',
  'strategic-data': 'Стратегические данные',
  'camera-point-id': 'Камера Point ID',
  'panorama-fov': 'Panorama Fov',
  'readiness-date': 'Дата готовности',
  'creation-date': 'Дата создания',
  'updating-date': 'Дата обновления',
  'work-time': 'Время работы',
  period: 'Период',
  mesh: 'Модель (FBX)',
  type: 'Тип',
  room: 'Комната',
  material: 'Материал',
  actions: 'Действия',
  'x-length': 'X',
  'y-length': 'Y',
  'z-length': 'Z',
  'z-location': 'Высота по-умолчанию',
  'is-scalable': 'Скалируемая',
  'is-procedural': 'Процедурная',
  environment: 'Окружение',
  'original-plan-id': 'ID Оригинальной планировки',
  additional: 'Дополнительно',
  renderer_version: 'Версия рендера',
  'sky-interior-cubemap-rotation': 'Поворот текстуры неба',
  'sky-interior-skylight-intensity': 'Яркость освещения',
  'sky-interior-skysphere-intensity': 'Яркость текстур',
  'expert-level-2d': 'Уровень 2D',
  'expert-level-3d': 'Уровень 3D',
  'beta-testing': 'Участвует в бета тестировании',
  'dataset-voter': 'Обучение нейронной сети',
  'can-get-plans-to-work': 'Возможность брать планировки',
  'single-floor-cutting': 'Одноэтажная обработка',
  'multiple-floor-cutting': 'Многоэтажная обработка',
  'selected-lossless-format': 'Формат изображения глубины',
  'img-has-been-deleted': 'Изображение удалено!',
  'plans-limit': 'Лимит взятия планировок',
  'reviewer-plans-limit': 'Лимит взятия планировок на проверку',
  'unreal-top-down-view-count': 'Количество изображений вокруг строения',
  'apply-middle-cut-in-top-view': 'Срединный срез (при съемке сверху)',
  'create-bitrix-order-lead': 'Создавать заказы в Bitrix',
  'create-bitrix-adjustment-lead': 'Создавать корректировки в Bitrix',
  'integration-with-bitrix': 'Интеграция с Bitrix',
  deprecated: 'Устаревшее',
  adjustments: 'Корректировки',
  archive: 'Архивировать',
  cancel: 'Отменить',
  'archive-furniture-confirmation': 'Вы уверены, что хотите архивировать мебель?',
  restore: 'Восстановить',
  'restore-furniture-confirmation': 'Вы уверены, что хотите восстановить мебель?',
  actual: 'Актуальное',
  'create-furniture-model': 'Создать модель',
  'create-furniture-model-title': 'Создание модели мебели',
  'select-furniture-name': 'Введите название мебели',
  'select-furniture-type': 'Введите тип мебели',
  'select-furniture-style': 'Введите стиль мебели',
  'select-room-type': 'Введите тип комнаты',
  'reset-filters': 'Сбросить фильтры',
  open: 'Открыть',
  'unreal-panorama-type': 'Тип панорамы',
  'middle-cut-height': 'Высота срединного среза',
  'camera-iso': 'ISO камеры',
  'is-furniture-enabled': 'Расстановка мебели',
  'is-furniture-lights-enabled': 'Расстановка света',
  'is-furniture-glass-walls-collapse-enabled': 'Схлопывание балконных стен',
  'is-furniture-curtains-radiators-enabled': 'Расстановка штор и радиаторов',
  'unreal-top-views-capture': 'Съёмка сверху',
  'unreal-top-down-views-capture': 'Съёмка сверху вокруг строения',
  'unreal-middle-cut-capture': 'Срединный срез',
  area: 'Площадь',
  'override-node-label': 'Сервер рендера',
  checklists: 'Чеклисты',
  'is-preview-generatable': 'Возможность сгенерировать превью',
};
